import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { InvitationDto, InviteUserInput } from '@cutlyft/zod-schemas';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

interface InviteUserApiResponse {
  success: boolean;
  data: InvitationDto;
}

/**
 * Mutation hook for inviting a new user by email.
 * Calls POST /users/invite.
 */
export function useInviteUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (input: InviteUserInput) => {
      const response = await apiClient.post<InviteUserApiResponse>('/users/invite', input);
      return response.data.data;
    },
    onSuccess: () => {
      // Invalidate the users list so that any UI displays active changes
      queryClient.invalidateQueries({ queryKey: queryKeys.users.list() });
    },
  });
}
